import _ from 'lodash'
import events from './events'
import axis from './axis'

function getGroupedEvents(data) {
  let toReturn = _.groupBy(data, 'timelineId')
  return Object.entries(toReturn).map((d) => d[1]).sort((a, b) => a[0].order - b[0].order)
}

function generate(data) {
  data.forEach(e => {
      e.duration = e.end ? e.end - e.start : 0
  })
  data.sort((a,b) => b.duration - a.duration)

  let groupedData = getGroupedEvents(data)

  let toReturn = []
  groupedData.forEach((group, index) => {
    group.forEach((data) => {
      data.position = index
      toReturn.push(data)
    })
  })

  return toReturn
}

function getHeight (data) {
  let groupedData = getGroupedEvents(data)
  return (groupedData.length) * (events.HEIGHT + events.MARGIN) + axis.MARGIN
}

export default {
  generate,
  getHeight
}